module.exports = __webpack_public_path__ + "static/img/default.4a1242c1.png";